import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Catalog } from '@cemex-core/cmx-api/models/catalogs/catalog';
import { CatalogEntry } from '@cemex-core/cmx-api/models/catalogs/catalog-entry';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Features } from '@ordersnproducts/features';
import { CatalogCodeType } from '../../../../../shared/constants/catalog-codes';
import { SelectOptionI } from '../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { distinctUntilChangedDeep } from '../../../../../shared/utils/distinct-until-changed-deep';
import { getSpecificationForm } from '../../../../reducers';
import { SpecificationFormState } from '../../reducers/specification/specification.reducer';

@Injectable()
export abstract class AbstractCatalogOptionLoader implements SelectOptionLoaderI {
  constructor(
    protected store: Store<SpecificationFormState>,
    protected featureToggleService: FeatureToggleService,
  ) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    let preselectDefaultOption = false;

    // Catalog values can be preselected for some countries based on feature toggles
    if (this.featureToggleService.isFeatureEnabled(Features.LoadDefaultCatalogValues)) {
      preselectDefaultOption = true;
    }

    return this.store.select(getSpecificationForm).pipe(
      distinctUntilChangedDeep(),
      map((state: SpecificationFormState) => {
        return state.catalogs.find((catalog) => {
          return catalog.catalogCode === this.getCatalogType();
        });
      }),
      filter((catalog) => catalog !== undefined),
      map((catalog: Catalog) => catalog.entries),
      map((entries: CatalogEntry[]) => {
        return entries.map((entry) => {
          return {
            id: entry.entryCode,
            name: entry.entryDesc,
            default: preselectDefaultOption ? entry.entryDefault : false,
          };
        });
      }),
    );
  }

  abstract getCatalogType(): CatalogCodeType;
}
